// extracted by mini-css-extract-plugin
export default {"mCard":"XD-z","image":"YD-z","imageNoBackground":"ZD-z","imageHasCategory":"_D-z","fullWidth":"aE-z"};